import {
    getSensorsAccessoriesPageConfig,
    SensorsAccessoriesPageData,
    SensorsAccessoriesPageVariables,
} from 'src/sensors/accessories/SensorsAccessoriesPageMapping.ts';
import { Suspense, useContext, useMemo } from 'react';
import { SkeletonMainLayout } from 'src/modules/common/skeletons/SkeletonMainLayout/SkeletonMainLayout.tsx';
import { Query } from 'src/modules/common/components/Query/Query.tsx';
import { SensorsCheckoutPage } from 'src/sensors/checkout/SensorsCheckoutPage.tsx';
import { ConfigContext } from 'src/configContext.ts';
import { useFilterLogic } from 'src/modules/common/hooks/useFilterLogic.ts';
import { buildCheckoutVariables } from 'src/sensors/checkout/buildCheckoutVariables.ts';
import { useLocationState } from 'src/sensors/useLocationState.ts';

export const PrefetchSensorsCheckout = () => {
    const [locationState,, searchParams] = useLocationState();

    const { userSettings, mandatoryFilterConfig } = useContext(ConfigContext);
    const pageConfig = useMemo(() => getSensorsAccessoriesPageConfig(userSettings.currentRegion), [userSettings]);
    if (pageConfig === null) {
        throw new Error('No Page Config!');
    }

    const [filter] = useFilterLogic(pageConfig.filterConfig, searchParams);

    const variables = useMemo(() => buildCheckoutVariables({
        mandatoryFilterConfig,
        filter,
        sensorLabel: locationState.sensorLabel,
        userSettings,
    }), [
        mandatoryFilterConfig,
        filter,
        locationState,
        userSettings,
    ]);

    return (
        <Suspense fallback={<SkeletonMainLayout breadcrumbs={false}/>}>
            <Query<SensorsAccessoriesPageData, SensorsAccessoriesPageVariables>
                query={pageConfig.query}
                variables={variables}
            >
                {({ data }) => {
                    if (data === undefined) {
                        return (<SkeletonMainLayout/>);
                    }
                    return (
                        <SensorsCheckoutPage
                            data={data}
                        />
                    );
                }}
            </Query>
        </Suspense>
    );
};
